import type { SVGProps } from 'react';

export const Guest = (props: SVGProps<any>) => (
  <svg
    height="20px"
    version="1.1"
    viewBox="0 0 20 20"
    width="20px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'Guest'}</title>
    <defs>
      <path
        d="M9.33270655,1.25357465 C7.08379363,1.25357465 5.25357465,3.08379363 5.25357465,5.33270655 C5.25357465,7.58287304 7.08379363,9.41183845 9.33270655,9.41183845 C11.582873,9.41183845 13.413092,7.58287304 13.413092,5.33270655 C13.413092,3.08379363 11.582873,1.25357465 9.33270655,1.25357465 M9.33270655,10.6654131 C6.39182043,10.6654131 4,8.27359267 4,5.33270655 C4,2.393074 6.39182043,0 9.33270655,0 C12.2735927,0 14.6666667,2.393074 14.6666667,5.33270655 C14.6666667,8.27359267 12.2735927,10.6654131 9.33270655,10.6654131 M1.79126566,18.0545973 C3.19700269,18.2588781 6.27205245,18.6471469 9.33267767,18.6471469 C12.3683878,18.6471469 15.461796,18.2575252 16.8740897,18.0532444 L15.1497014,13.3074359 C14.3550404,12.9813983 11.7992741,12.0195197 9.33267767,12.0195197 C7.03393045,12.0195197 4.34965461,12.9895154 3.51303126,13.3142001 L1.79126566,18.0545973 Z M9.33267767,20 C5.08924014,20 0.958576279,19.2965164 0.784170472,19.2667536 L0,19.1301155 L2.48888889,12.2792675 L2.75246458,12.1669807 C2.89802131,12.1074552 6.32843929,10.6666667 9.33267767,10.6666667 C12.5677087,10.6666667 15.7909378,12.1128666 15.926004,12.173745 L16.1804004,12.2887375 L18.6666667,19.1314683 L17.8811849,19.2667536 C17.7054677,19.2965164 13.5380869,20 9.33267767,20 L9.33267767,20 Z"
        id="path-1"
      ></path>
    </defs>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-57.000000, -83.000000)">
        <g transform="translate(57.000000, 83.000000)">
          <rect height="20" width="20" x="0" y="0"></rect>
          <g transform="translate(0.666667, 0.000000)">
            <mask fill="white">
              <use xlinkHref="#path-1"></use>
            </mask>
            <use fill="#8C8C8C" xlinkHref="#path-1"></use>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
